import { MdDeleteForever } from "react-icons/md";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { deleteCartItem, PostAddSalectItems } from "../../../../redux/slices/addToCart";
import { useCallback, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";

export default function OrderSummary({ cartData }) {
    const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
    const dispatch = useDispatch();
    const [selectedItems, setSelectedItems] = useState({});

    const handleDelete = useCallback((itemId) => {
        dispatch(deleteCartItem(itemId, toast));
    }, [dispatch]);

    useEffect(() => {
        const initialSelectedState = cartData.reduce((acc, item) => {
            acc[item.id] = item.selected;
            return acc;
        }, {});
        setSelectedItems(initialSelectedState);
    }, [cartData]);

    const handleCheckboxChange = async (e, itemId) => {
        try {
            const isChecked = e.target.checked;
            const payload = { selected: isChecked };
            dispatch(PostAddSalectItems(payload, itemId, toast));
            setSelectedItems((prev) => ({ ...prev, [itemId]: isChecked }));
        } catch (error) {
            toast.error('An error occurred');
        }
    };

    const getSelectedVariantPrice = (item) => {
        try {
            const variants = typeof item.selected_variants === 'string'
                ? JSON.parse(item.selected_variants)
                : item.selected_variants;

            for (const key in variants) {
                const variant = variants[key];
                if (variant?.id === item.variant_id) {
                    return {
                        price: parseFloat(variant.price || 0),
                        discount: variant.discount_price ? parseFloat(variant.discount_price) : null
                    };
                }
            }

            return {
                price: parseFloat(item.price || 0),
                discount: item.discount_price ? parseFloat(item.discount_price) : null
            };

        } catch {
            return { price: parseFloat(item.price || 0), discount: null };
        }
    };

    const getVariantValues = (item) => {
        if (!item.selected_variants) return '';
        try {
            const variants = typeof item.selected_variants === 'string'
                ? JSON.parse(item.selected_variants)
                : item.selected_variants;
            return Object.values(variants).map(v => v?.value).join(" ");
        } catch {
            return '';
        }
    };

    return (
        <div className="overflow-x-auto max-h-[460px] overflow-y-auto">
            <table className="w-full mt-6">
                <tbody>
                    {cartData?.map((item, index) => {
                        const { price, discount } = getSelectedVariantPrice(item);
                        const variantText = getVariantValues(item);
                        const finalPrice = discount ? discount * item.quantity : price * item.quantity;
                        const originalPrice = price * item.quantity;

                        return (
                            <tr key={index} className="flex shadow-md glass_effect rounded-lg my-3 bg-white justify-between">
                                <td className="flex items-center py-4 px-3 gap-3 w-[60%]">
                                    <div className='rounded-md w-20 h-20 sm:block hidden'>
                                        <div className="relative h-full w-full">
                                            <img
                                                src={BASE_IMAGE_URL + item?.additional_images[0]}
                                                alt='product_img'
                                                className='h-full w-full rounded-md object-cover'
                                            />
                                            <div className="absolute left-1 top-1">
                                                <FormProvider>
                                                    <FormContent
                                                        isChecked={selectedItems[item.id]}
                                                        onCheckboxChange={(e) => handleCheckboxChange(e, item.id)}
                                                    />
                                                </FormProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-center flex-col max-w-[160px]">
                                        <h2 className="text-white text-left font-dm text-sm capitalize font-medium truncate">
                                            {item?.name}
                                        </h2>
                                        {variantText && (
                                            <p className="text-white text-xs mt-1 truncate">({variantText})</p>
                                        )}
                                        <h2 className="text-white text-left font-dm text-sm mt-1">
                                            Qty: {item?.quantity}
                                        </h2>
                                    </div>
                                </td>

                                <td className="flex items-center py-4 px-2 gap-2 w-[30%] justify-end">
                                    <p className="text-sm font-dm text-white text-right">
                                        ₹{finalPrice.toFixed(2)}
                                        {discount && (
                                            <span className="text-gray-400 line-through ml-1 text-xs block">
                                                ₹{originalPrice.toFixed(2)}
                                            </span>
                                        )}
                                    </p>
                                </td>

                                <td
                                    className="flex items-center py-4 px-2 gap-2 w-[10%] justify-end cursor-pointer"
                                    onClick={() => handleDelete(item?.id)}
                                >
                                    <MdDeleteForever className="text-white text-xl" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

function FormContent({ isChecked, onCheckboxChange }) {
    return (
        <form className="w-fit">
            <label className="custom-checkbox">
                <input
                    type="checkbox"
                    checked={isChecked || false}
                    onChange={onCheckboxChange}
                />
                <span className="checkmark"></span>
            </label>
        </form>
    );
}
